// 各种mutation类型

// 用户模块
// export const LOGOUT = 'LOGOUT'
// export const LOGIN = 'LOGIN'
export const LOGINURL = 'LOGINURL'



// WEBPACK FOOTER //
// ./src/store/mutation.types.js